import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const ContentCreatorProgram = () => {
  return (
    <div className="content-creator-page bg-light my-5">
      {/* SECTION 1: Hero Section */}
      <section className="bg-dark text-light text-center py-5 my-5">
        <div className="container">
          <h1 className="display-5 fw-bold">
            Olewin Academy — Content Creator & Partnership Program
          </h1>
          <p className="lead mt-3">
            Become India’s first generation of Edu-Creators! Empower learners,
            promote our training programs, and earn bonuses while learning.
          </p>
          <a href="https://olewingroup.com/digitalservices/" className="btn btn-warning btn-lg mt-3" target="blank">
            Join Now
          </a>
        </div>
      </section>

      {/* SECTION 2: About Program */}
      <section className="py-5">
        <div className="container text-center">
          <h2 className="fw-bold mb-4">About the Program</h2>
          <p className="text-muted fs-5">
            Olewin Academy — India’s 1st Research & Training Academy offering
            paid internships and real-time learning.  
            This program is designed for passionate creators, influencers, and
            interns who want to promote educational programs like IIT-JEE, NEET,
            GATE, IIT-JAM, CA, LAW, and Abroad Studies.
          </p>
        </div>
      </section>

      {/* SECTION 3: How It Works */}
      <section className="bg-white py-5">
        <div className="container">
          <h2 className="fw-bold text-center mb-5">How It Works</h2>
          <div className="row text-center">
            {[
              {
                title: "1️⃣ Register as a Creator",
                desc: "Sign up for our program and get access to all marketing materials, brand kits, and course brochures.",
              },
              {
                title: "2️⃣ Promote Academy Programs",
                desc: "Share videos, posts, or reels about IIT-JEE, NEET, GATE, LAW, etc., and encourage enrollments.",
              },
              {
                title: "3️⃣ Earn Commissions & Bonuses",
                desc: "Receive up to 25% bonus per enrollment brought by your content, plus performance-based rewards.",
              },
            ].map((step, i) => (
              <div className="col-md-4 mb-4" key={i}>
                <div className="card h-100 shadow-sm border-0">
                  <div className="card-body">
                    <h5 className="fw-bold">{step.title}</h5>
                    <p className="text-muted">{step.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 4: Benefits for Content Creators */}
      <section className="bg-dark text-light py-5">
        <div className="container">
          <h2 className="text-center fw-bold mb-5">Benefits & Rewards</h2>
          <div className="row">
            {[
              "Earn up to ₹10,000+ per month through enrollments.",
              "Gain official certification and internship letter from Olewin Academy.",
              "Get exclusive access to our online programs for free or at discounted rates.",
              "Collaborate with our instructors to create branded content.",
              "Build your digital portfolio and boost your LinkedIn profile.",
              "Top performers get featured on our official social media platforms.",
            ].map((benefit, index) => (
              <div className="col-md-6 mb-3" key={index}>
                <div className="p-3 border rounded bg-secondary bg-opacity-25">
                  {benefit}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 5: Revenue Model */}
      <section className="py-5">
        <div className="container text-center">
          <h2 className="fw-bold mb-4">Revenue Sharing Model</h2>
          <p className="text-muted fs-5 mb-4">
            You create — we train — together we grow.  
            Our transparent and rewarding revenue-sharing model ensures that
            creators earn based on their performance.
          </p>
          <div className="table-responsive">
            <table className="table table-bordered table-striped align-middle">
              <thead className="table-dark">
                <tr>
                  <th>Tier</th>
                  <th>Enrollments per Month</th>
                  <th>Bonus per Enrollment</th>
                  <th>Extra Rewards</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Starter</td>
                  <td>1–10</td>
                  <td>₹2000</td>
                  <td>Certificate of Recognition</td>
                </tr>
                <tr>
                  <td>Pro Creator</td>
                  <td>11–30</td>
                  <td>₹3000</td>
                  <td>Bonus ₹2,000</td>
                </tr>
                <tr>
                  <td>Elite Partner</td>
                  <td>30+</td>
                  <td>₹5000</td>
                  <td>Featured on Olewin Website</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* SECTION 6: Apply Now / Contact */}
      <section id="apply" className="bg-warning py-5">
        <div className="container text-center">
          <h2 className="fw-bold mb-3 text-dark">Join the Program Today!</h2>
          <p className="fs-5 text-dark mb-4">
            Start your journey as an Edu-Creator. Promote quality education,
            earn rewards, and grow with Olewin Academy.
          </p>
          <a
            href="mailto:olewinacademy@gmail.com"
            className="btn btn-dark btn-lg px-5"
          >
            Apply via Email
          </a>
          <div className="mt-4 text-dark">
            <p>
              📍 Visit us: <strong>www.olewingroup.com/digitalservices</strong>
            </p>
            <p>📞 Contact: +91- 8639449423</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContentCreatorProgram;
